import { BitmapText, Container } from '@pixi/react'
import { SymbolData } from '../domain/game/model/SymbolData'
import { Image } from '@slot-nx/core'
import { ContainNameType } from '../domain/game/enum/ContainNameType'
import { gameConfig } from '../config'
import { getSymbolImg } from '../domain/game/util/gameUtil'
import { SymbolType } from '../domain/game/enum/SymbolType'

interface SymbolProps {
  x: number
  y: number
  data: SymbolData
}

const width = gameConfig.nodeWidth
const height = gameConfig.nodeHeight

export const SlotSymbol = (props: SymbolProps) => {
  const { data } = props
  const isMultiplierSymbol = data.type === SymbolType.S1

  return (
    <Container x={props.x} y={props.y}>
      <Image
        name={ContainNameType.SymbolImage}
        anchor={0.5}
        position={[width / 2, height / 2]}
        image={getSymbolImg(data)}
      />
      <BitmapText
        name={ContainNameType.SymbolMulpitlierNumber}
        anchor={[0.5, 0.5]}
        style={{ fontName: 'fontB', fontSize: 20 }}
        x={gameConfig.nodeWidth / 2 + 2}
        y={gameConfig.nodeHeight / 2 - 6}
        text={String(isMultiplierSymbol ? `${data.multiplier}X` : '')}
      />
    </Container>
  )
}
